module.exports = __webpack_public_path__ + "static/media/poly.c8e486c0.png";